import React from 'react';
import UnderlinedInput from 'swag-client-common/components/inputs/underlined-input';
import { RectangleInput } from 'swag-client-common/components/inputs/rectangle-input-v2';
import PasswordStrengthMeter from 'swag-client-common/components/ui/password-strength-meter';
import classes from './password-input.scss';
export const UnderlinedPasswordInput = props => /*#__PURE__*/React.createElement(UnderlinedInput, props, /*#__PURE__*/React.createElement(PasswordStrengthMeter, {
  className: classes.strengthMeter,
  password: props.input.value,
  isAllPasswordRequirementsCompleted: props.isAllPasswordRequirementsCompleted
}));
export const RectanglePasswordInput = props => {
  var _props$input;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.rectanglePasswordInput
  }, /*#__PURE__*/React.createElement(RectangleInput, props), /*#__PURE__*/React.createElement(PasswordStrengthMeter, {
    className: classes.strengthMeter,
    password: (_props$input = props.input) === null || _props$input === void 0 ? void 0 : _props$input.value,
    isAllPasswordRequirementsCompleted: props.isAllPasswordRequirementsCompleted
  }));
};